<template>
<div>
  <!-- Preloader Starts -->
  <div class="preloader">
    <div class="spinner"></div>
  </div>
  <!-- Preloader End -->

  <!-- Header Area Starts -->
  <header class="header-area single-page">
    <div class="header-top" style="padding: 10px 0;">
      <div class="container">
        <div class="row">
          <div class="col-lg-2">
            <div class="logo-area">
              <router-link to="/">
                <img src="https://dianjinyunflex-prod.oss-cn-beijing.aliyuncs.com/file/menhu/logo-light.png" alt="logo" style="width: 70px;margin-top: 0;">
                <span style="color: #fff;font-weight: 600;font-size: 18px;line-height: 37px;">点金云</span>
              </router-link>
            </div>
          </div>
          <div class="col-lg-10" style="line-height: 37px;">
            <div class="custom-navbar">
              <span></span>
              <span></span>
              <span></span>
            </div>
            <div class="main-menu main-menu-light">
              <ul>
                <li><router-link to="/" style="font-size: 17px;">首页</router-link></li>
                <li><router-link to="/about" style="font-size: 17px;">灵活用工</router-link></li>
                <li><router-link to="/contact" style="font-size: 17px;">解决方案</router-link></li>
                <li><router-link to="/category" style="font-size: 17px;">新闻资讯</router-link></li>
<!--                <li><a href="#">blog</a>-->
<!--                  <ul class="sub-menu">-->
<!--                    <li><router-link to="/blog">Blog Home</router-link></li>-->
<!--                    <li><router-link to="/blogDetails">Blog Details</router-link></li>-->
<!--                  </ul>-->
<!--                </li>-->

                <li><router-link to="/elements" style="font-size: 17px;">关于我们</router-link></li>

                <li><a style="font-size: 17px;" href="https://shgl.dianjinyun.cn/" target="_blank">商户系统</a></li>

<!--                <li><a href="#">pages</a>-->
<!--                  <ul class="sub-menu">-->
<!--                    <li><router-link to="/jobSearch">Job Search</router-link></li>-->
<!--                    <li><router-link to="/jobSingle">Job Single</router-link></li>-->
<!--                    <li><router-link to="/pricingPlan">Pricing Plan</router-link></li>-->
<!--                    <li><router-link to="/elements">Elements</router-link></li>-->
<!--                  </ul>-->
<!--                </li>-->
<!--                <li class="menu-btn">-->
<!--                  <a href="#" class="login">log in</a>-->
<!--                  <a href="#" class="template-btn">sign up</a>-->
<!--                </li>-->
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
<!--    <div class="page-title text-center">-->
<!--      <div class="container">-->
<!--        <div class="row">-->
<!--          <div class="col-md-6 offset-md-3">-->
<!--            <h2>自由职业者   一站式服务平台</h2>-->
<!--            <p>多种就业形势，推动个人灵活就业</p>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
  </header>
  <!-- Header Area End -->

  <router-view></router-view>

  <!-- Footer Area Starts -->
  <footer class="footer-area" style="padding: 20px 0;background: #444447;">
<!--    <div class="footer-widget">-->
<!--      <div class="container">-->
<!--        <div class="row">-->
<!--&lt;!&ndash;          <div class="col-xl-2 col-lg-3">&ndash;&gt;-->
<!--&lt;!&ndash;            <div class="single-widget-home mb-5 mb-lg-0">&ndash;&gt;-->
<!--&lt;!&ndash;              <h3 class="mb-4">联系方式</h3>&ndash;&gt;-->
<!--&lt;!&ndash;              <ul>&ndash;&gt;-->
<!--&lt;!&ndash;                <li class="mb-2">邮箱：</li>&ndash;&gt;-->
<!--&lt;!&ndash;                <li class="mb-2">地址：</li>&ndash;&gt;-->
<!--&lt;!&ndash;                <li class="mb-2">热线：</li>&ndash;&gt;-->
<!--&lt;!&ndash;              </ul>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--&lt;!&ndash;          </div>&ndash;&gt;-->
<!--&lt;!&ndash;          <div class="col-xl-5 offset-xl-1 col-lg-6">&ndash;&gt;-->
<!--&lt;!&ndash;            <div class="single-widget-home mb-5 mb-lg-0">&ndash;&gt;-->
<!--&lt;!&ndash;              <h3 class="mb-4">newsletter</h3>&ndash;&gt;-->
<!--&lt;!&ndash;              <p class="mb-4">You can trust us. we only send promo offers, not a single.</p>&ndash;&gt;-->
<!--&lt;!&ndash;              <form action="#">&ndash;&gt;-->
<!--&lt;!&ndash;                <input type="email" placeholder="Your email here" onfocus="this.placeholder = ''" onblur="this.placeholder = 'Your email here'" required>&ndash;&gt;-->
<!--&lt;!&ndash;                <button type="submit" class="template-btn">subscribe now</button>&ndash;&gt;-->
<!--&lt;!&ndash;              </form>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--&lt;!&ndash;          </div>&ndash;&gt;-->
<!--          <div class="col-xl-3 offset-xl-5 col-lg-3">-->
<!--            <div class="single-widge-home">-->
<!--&lt;!&ndash;              <h3 class="mb-4">二维码</h3>&ndash;&gt;-->
<!--              <div class="feed">-->
<!--                <img src="static/assets/images/feed1.jpg" alt="feed" style="width: 200px;height: 200px">-->

<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <div class="footer-copyright" style="margin-top: 0px;text-align: center">
      <div class="container">
        <div style="text-align: center;font-size: 14px;">
                © 2025 北京点金企服科技有限公司 版权所有 京ICP备2025135183号
<!--          <div class="col-lg-4 col-md-6">-->
<!--            <div class="social-icons">-->
<!--              <ul>-->
<!--                <li><a href="#"><i class="fa fa-facebook"></i></a></li>-->
<!--                <li><a href="#"><i class="fa fa-twitter"></i></a></li>-->
<!--                <li><a href="#"><i class="fa fa-dribbble"></i></a></li>-->
<!--                <li><a href="#"><i class="fa fa-behance"></i></a></li>-->
<!--              </ul>-->
<!--            </div>-->
<!--          </div>-->
        </div>
      </div>
    </div>
  </footer>
  <!-- Footer Area End -->

</div>
</template>
<script>
export default {
  name: 'app'
}
</script>

<style>
.router-link-exact-active{
  color: #d9ea96 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue